import { useEffect, useState } from "react";
import { X, Download } from "lucide-react";

const DISMISS_KEY = "nst_install_dismissed";

const safeGet = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const safeSet = (k, v) => { try { localStorage.setItem(k, v); } catch {} };

export const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (safeGet(DISMISS_KEY)) return;
    if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setVisible(false);
  };

  const dismiss = () => {
    safeSet(DISMISS_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-black text-[#FAF7F0] border-t border-[#FAF7F0]/30"
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-4">
        <p className="font-body text-sm">
          Install <span className="italic">The New School of Thoughts</span> on your device for quick access.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="pwa-install-button"
            onClick={install}
            className="flex items-center gap-2 border border-[#FAF7F0] px-4 py-2 text-xs uppercase tracking-widest hover:bg-[#FAF7F0] hover:text-black transition-colors"
          >
            <Download size={14} /> Install
          </button>
          <button data-testid="pwa-install-dismiss" onClick={dismiss} aria-label="Dismiss" className="p-1 opacity-70 hover:opacity-100">
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};
